import { render } from "./CorrespondingVerses.vue?vue&type=template&id=7a8a04da&ts=true"
import script from "./CorrespondingVerses.vue?vue&type=script&lang=ts"
export * from "./CorrespondingVerses.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__